import React from 'react';
import PropTypes from 'prop-types';
import { Img } from '../../../../hybrid/wrappers';
import css from './ImgText.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';

const ImgText = ({ getHandlers, gridStyles, name, val }) => {
    const { stylers, classes } = generateGridStyles(gridStyles, name);
    return (
        <div {...getHandlers(false)} className={classnames(css.imageTextCell, classes.wrapper)} style={stylers.wrapper}>
            {val.image ? <Img className={css.imageTextCellImg} src={val.image} /> : <div className={css.imageTextCellImg} />}
            <p>{`${val.name}`}</p>
        </div>
    );
};
ImgText.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    name: PropTypes.string,
    link: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default ImgText;
